<template>
  <div>
    <div class="mb-5">
      <h2>
        Балансы учеников
      </h2>
      <vue-good-table
          :columns="columns"
          :rows="balances"
          :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
          :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      >
        <template
            slot="table-row"
            slot-scope="props"
        >

          <!-- Column: Name -->
          <div
              v-if="props.column.field === 'balance'"
              class="text-nowrap"
          >
            <span class="text-nowrap">{{ props.row.account.balance }}</span>
          </div>
          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'trial_status_id'">
          <b-badge>
            {{ getModelName('trialStatuses', props.row.trial_status_id, 'name') }}
          </b-badge>
        </span>

          <!-- Column: Common -->
          <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
        </template>

        <!-- pagination -->
        <template
            slot="pagination-bottom"
            slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
              <b-form-select
                  v-model="pageLength"
                  :options="['3','5','10']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
              />
              <span class="text-nowrap "> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
    <div class="mb-5">
      <h2>
        Балансы учителей
      </h2>
      <vue-good-table
          :columns="columns"
          :rows="teachers"
          :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
          :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      >
        <template
            slot="table-row"
            slot-scope="props"
        >

          <!-- Column: Name -->
          <div
              v-if="props.column.field === 'balance'"
              class="text-nowrap"
          >
            <span class="text-nowrap">{{ props.row.account.balance }}</span>
          </div>
          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'trial_status_id'">
          <b-badge>
            {{ getModelName('trialStatuses', props.row.trial_status_id, 'name') }}
          </b-badge>
        </span>

          <!-- Column: Common -->
          <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
        </template>

        <!-- pagination -->
        <template
            slot="pagination-bottom"
            slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
              <b-form-select
                  v-model="pageLength"
                  :options="['3','5','10']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
              />
              <span class="text-nowrap "> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>

import {BFormSelect, BPagination} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import {createNamespacedHelpers} from 'vuex';
import formattedDate from '@/mixins/formattedDate'
import CRMApi from '@/api/crm'

const {mapState, mapActions, mapMutations} = createNamespacedHelpers('crm')

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormSelect,
  },
  mixins: [formattedDate],
  computed: {
    ...mapState({
      teachers: state => state.teachers
    })
  },
  data() {
    return {
      pageLength: 3,
      dir: false,
      columns: [
        {
          label: 'Имя',
          field: 'name',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Баланс',
          field: 'balance',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
      balances: [],
    }
  },
  methods: {
    ...mapActions(['getUsers']),
    getBalances() {
      CRMApi.getBalances()
          .then(res => {
            this.balances = res.data
          })
          .catch(err => {
            console.log(err)
          })
    }
  },
  created() {
    this.getUsers()
    this.getBalances()
  },
  mounted() {
    console.log(this.teachers)
  }
}
</script>

<style scoped>

</style>
